// The lifecycle reason a repair was carried out; drives the coloured state label on the card.
export type RepairState = 'warranty' | 'obligingness' | 'invoice';

export const REPAIR_STATES = ['warranty', 'obligingness', 'invoice'] as const;

// A single repair record for a device. At most one document is attached; documentAvailable is
// true once its upload has been enabled and it can be opened.
export interface RepairHistoryEntry {
  id: string;
  deviceId: string;
  date: string; // YYYY-MM-DD
  state: RepairState;
  name: string;
  documentAvailable: boolean;
}

export interface CreateRepairRequest {
  deviceId: string;
  date: string;
  state: RepairState;
  name: string;
}

// Every entry field is optional so the update call can send only what actually changed.
export type UpdateRepairRequest = Partial<Pick<RepairHistoryEntry, 'date' | 'state' | 'name'>>;
